import { authContext } from "@/components/AuthProvider";
import { useContext } from "react";

const useAuth = () => useContext(authContext);

export default useAuth;
